@if (blocked) {
  <p-blockui *transloco="let t" [blocked]="blocked">
    <div
      class="fixed inset-0 z-[9999] flex flex-col items-center justify-center text-center text-white transition-colors duration-500 {{
        messageVisible ? 'bg-grey-darker/75' : ''
      }}"
    >
      <span
        class="text-white text-8xl icon-spinner-outline animate-spin pi-original duration-3000"
      ></span>
      <div
        class="{{
          messageVisible ? 'opacity-100' : 'opacity-0'
        }} mt-2 transition-all delay-100 duration-200"
      >
        <p>
          {{ t("long_operation_message") }}
        </p>
        <p>
          <span
            class="inline-block p-2 px-4 py-3 mt-3 font-medium leading-none bg-white cursor-pointer text-grey-darker hover:text-orange"
            (click)="unBlock()"
            >{{ t("close_and_continue") }}</span
          >
        </p>
      </div>
    </div>
  </p-blockui>
}
